import PropTypes from 'prop-types';

import mapPointShape from './mapPoint';

export default {
  id: PropTypes.string.isRequired,
  country: {
    countryIsoCode: PropTypes.string.isRequired
  },
  currencyIsoCode: PropTypes.string.isRequired,
  areaId: PropTypes.number.isRequired,
  center: PropTypes.shape(mapPointShape),
  limits: PropTypes.shape({
    sw: PropTypes.shape(mapPointShape),
    ne: PropTypes.shape(mapPointShape)
  }),
  minimumStaying: PropTypes.number,
  otherCitiesInCountry: PropTypes.arrayOf(PropTypes.string),
  allCities: PropTypes.arrayOf(PropTypes.string)
};
